const CONTEXT_MESH_DESTINATIONS = new Set(["refresh-product", "integrations", "uploads"]);

/**
 * The contextual return action is intentionally one-hop: it is available only
 * on a destination opened directly from Context Mesh, never on the same page
 * reached from the navigation rail or another workflow.
 */
export function shouldShowContextMeshReturn(previousView: string, nextView: string): boolean {
    return previousView === "mesh-strength" && CONTEXT_MESH_DESTINATIONS.has(nextView);
}
